import { create } from "zustand";

export type AvatarProvider = "simli" | "liveavatar";

interface AvatarState {
  /** Active avatar provider — driven by VITE_AVATAR_PROVIDER env var */
  provider: AvatarProvider;
  /** Whether the avatar widget is visible */
  avatarVisible: boolean;
  /** Whether the avatar session is connected and ready */
  isConnected: boolean;
  /** Whether the avatar is currently speaking */
  isSpeaking: boolean;
  /** Text queued to be spoken by the avatar */
  pendingText: string;
  /** Connection error message */
  error: string | null;

  setProvider: (provider: AvatarProvider) => void;
  setAvatarVisible: (visible: boolean) => void;
  toggleAvatarVisible: () => void;
  setConnected: (connected: boolean) => void;
  setSpeaking: (speaking: boolean) => void;
  setPendingText: (text: string) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useAvatarStore = create<AvatarState>((set) => ({
  provider: (import.meta.env.VITE_AVATAR_PROVIDER as AvatarProvider) || "simli",
  avatarVisible: true,
  isConnected: false,
  isSpeaking: false,
  pendingText: "",
  error: null,

  setProvider: (provider) => set({ provider }),
  setAvatarVisible: (visible) => set({ avatarVisible: visible }),
  toggleAvatarVisible: () => set((s) => ({ avatarVisible: !s.avatarVisible })),
  setConnected: (connected) => set({ isConnected: connected }),
  setSpeaking: (speaking) => set({ isSpeaking: speaking }),
  setPendingText: (text) => set({ pendingText: text }),
  setError: (error) => set({ error }),
  reset: () =>
    set({
      avatarVisible: false,
      isConnected: false,
      isSpeaking: false,
      pendingText: "",
      error: null,
    }),
}));
